import React, { Component } from "react";
import { Route } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import banner_img from "../../images/banner-profile.jpg";

class Location extends Component {
  render() {
    return (
      <div>
        <Route component={Header} />
        <div id="giveMargin" className="">
          <img src={banner_img} alt="banner-profile" className="w-100" />
          <section className="termscondbody mt-5 mb-5">
            <div className="container p-3">
              <h2 className="text-secondary">LOCATION MAP</h2>
              <div className="row g-3 w-100 mx-auto">
                <div className="col-md-12 mt-5 bg-light d-flex">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14601.569181151559!2d90.4157514!3d23.8046453!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7abd941ed15%3A0xf151df4e4e9c047c!2sUnited%20Hospital%20Limited!5e0!3m2!1sen!2sbd!4v1680602460479!5m2!1sen!2sbd"
                    width="100%"
                    height="600"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Route component={Footer} />
      </div>
    );
  }
}
export default Location;



// WEBPACK FOOTER //
// ./src/component/frontend/Location.js